import React from "react";
import { Nav } from "@/components/landing/Nav";
import { Footer } from "@/components/landing/Footer";
import { Pricing as PricingSection } from "@/components/landing/Pricing";
import { FAQ } from "@/components/landing/FAQ";
import { AdRevenue } from "@/components/landing/AdRevenue";

export default function PricingPage() {
    return (
        <div className="paper-grain min-h-screen">
            <Nav/>
            <main className="pt-20">
                <div className="text-center pt-20 pb-6 mx-auto max-w-3xl px-5">
                    <p className="text-[11px] uppercase tracking-[0.22em] font-semibold text-coral mb-5">Pricing</p>
                    <h1 className="h-display text-[56px] sm:text-[88px] lg:text-[112px] text-ink">
                        Pay in <span className="italic-display text-coral">BDT.</span><br/>Pay only for what you use.
                    </h1>
                </div>
                <PricingSection/>
                <AdRevenue/>
                <FAQ/>
            </main>
            <Footer/>
        </div>
    );
}
